import { Resource } from './resource';
import { FileUpload } from './fileUpload';
import { JobDescription } from './jobDescription';

export class JobDescriptionDocument extends Resource {
  jobDescription: JobDescription;
  file: FileUpload;
}